import { Calendar } from '@/components/ui/calendar';
import { useState } from 'react';
import { events } from '@/data/site';
import { usePageContent } from '@/context/SiteDataContext';
import PageHero from '@/components/PageHero';

export default function CalendarPage() {
  const c = usePageContent('calendar');
  const [date, setDate] = useState(new Date());
  const eventsOnDate = events.filter(e => new Date(e.date).toDateString() === date?.toDateString());

  return (
    <div>
      <PageHero slug="calendar" overline="Plan With Us" heading="Calendar" />
      <section className="bg-white py-20">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-10">
          <div className="card-tactile p-6 flex justify-center">
            <Calendar mode="single" selected={date} onSelect={setDate} className="rounded-md" />
          </div>
          <div>
            <div className="overline mb-3">{date?.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}</div>
            <h2 className="font-serif text-3xl text-royal font-bold mb-6">Events</h2>
            {eventsOnDate.length ? eventsOnDate.map(e => (
              <div key={e.id} className="card-tactile p-6 mb-4">
                <div className="text-xs text-gold uppercase tracking-widest">{e.department}</div>
                <div className="font-serif text-xl text-royal font-bold mt-1">{e.title}</div>
                <div className="text-sm text-charcoal-muted mt-2">{e.time} · {e.location}</div>
              </div>
            )) : <p className="text-charcoal-muted">No events scheduled for this day.</p>}
            <div className="mt-8">
              <h3 className="font-serif text-xl text-royal font-bold mb-3">All Upcoming</h3>
              <div className="space-y-2">
                {events.map(e => (
                  <div key={e.id} className="flex justify-between items-center p-3 rounded-lg border border-gray-100">
                    <div>
                      <div className="text-sm font-semibold text-royal">{e.title}</div>
                      <div className="text-xs text-charcoal-muted">{new Date(e.date).toLocaleDateString()}</div>
                    </div>
                    <div className="text-xs text-gold">{e.department}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
